// extracted by mini-css-extract-plugin
export default {"page":"SolutionDetail_page__Tk2Xe"};